<template>
  <nx-fullscreen-dialog :active="active" @dismiss="dismiss" title="Multimedia" classes="nx-primary--lighten-5">
    <template slot="toolbar-items">
        <v-btn
          @click="accept"
          color="accent"
          dark
          flat
          :disabled="!validForm"
        >{{ $t('message.common.accept') }}</v-btn>
    </template>
    <v-container v-if="active">
      <nx-form-scope-card title="Texto" icon="text_fields" v-if="includeRichText">
        <!-- v-flex xs12>
            <nx-form-select
              name="textPosition"
              :label="$t('message.form.fields.textHorizontalPosition')"
              :items="textHorizontalPositionItems"
              :value="draft.textPosition"
              default="center"
            />
        </v-flex -->
          <v-flex xs12>
            <nx-form-content-editor
              class="mx-4"
              name="text"
              type="scrollytelling"
              :label="$t('message.form.fields.body')"
              :sidebar-options="sidebarOptions"
              :value="draft.text"
            />
          </v-flex>
      </nx-form-scope-card>
      <nx-form-scope-card title="Imagen" icon="image" class="mt-1">
        <v-flex xs12>
          <nx-scrollytelling-slide-editor-form-image-field
            desktop-image-name="desktopImage"
            mobile-image-name="mobileImage"
            image-alt-name="imageAlt"
            :desktop-image-value="draft.desktopImage"
            :mobile-image-value="draft.mobileImage"
            :image-alt-value="draft.imageAlt"
            required
            @selection="updateAlt"
          />
        </v-flex>
      </nx-form-scope-card>
    </v-container>
  </nx-fullscreen-dialog>
</template>

<script>
import NxFullscreenDialog from '@/components/dialogs/FullscreenDialog';
import isEmpty from 'lodash/isEmpty';
import cloneDeep from 'lodash/cloneDeep';
import NxScrollytellingSlideEditorFormImageField from './ScrollytellingSlideEditorFormImageField';
import NxFormScopeCard from '@/modules/form/components/FormScopeCard';
import NxFormContentEditor from '@/modules/form/components/FormContentEditor';

export default {
  name: 'nx-scrollytelling-slide-multimedia-editor',
  components: {
    NxFormScopeCard,
    NxFullscreenDialog,
    NxScrollytellingSlideEditorFormImageField,
    NxFormContentEditor,
  },
  inject: ['$validator'],
  provide() {
    return {
      $parentForm: this,
    };
  },
  props: {
    active: {
      type: Boolean,
    },
    value: {
      type: Object,
      default: () => ({}),
    },
    includeRichText: {
      type: Boolean,
    },
  },
  data() {
    return {
      draft: {},
    };
  },
  computed: {
    sidebarOptions() {
      return [
        'ql-scrollytelling-spacer',
        'ql-scrollytelling-image',
        'ql-video',
        'ql-tweet',
        'ql-youtube',
        'ql-facebook',
        'ql-instagram',
        'ql-code',
      ];
    },
    validForm() {
      return this.draft.imageAlt
        && this.draft.desktopImage
        && this.draft.mobileImage;
    },
    textHorizontalPositionItems() {
      return [
        {
          text: this.$t('message.common.left'),
          value: 'left',
        },
        {
          text: this.$t('message.common.center'),
          value: 'center',
        },
        {
          text: this.$t('message.common.right'),
          value: 'right',
        },
      ];
    },
  },
  watch: {
    value(val) {
      this.draft = isEmpty(val) ? {} : cloneDeep(val);
    },
  },
  methods: {
    updateAlt(value) {
      if (this.draft.desktopImage) {
        this.$set(this.draft, 'imageAlt', this.draft.desktopImage.name);
        return;
      }
      if (this.draft.mobileImage) {
        this.$set(this.draft, 'imageAlt', this.draft.mobileImage.name);
      }
    },
    accept() {
      this.$emit('input', this.draft);
      this.draft = {};
    },
    dismiss() {
      this.$emit('dismiss');
      this.draft = {};
    },
    updateField(name, value) {
      this.$set(this.draft, name, value);
    },
  },
};
</script>
